module.exports = __webpack_public_path__ + "static/media/teeth.0c372b01.png";